<template>
  <module-block
    class="home-instructions"
    block="lightest"
  >
    <h2 class="h2 home-instructions__heading mt0">You play a critical role in driving quality in dentistry</h2>
    <div class="home-instructions__inner group group--last">
      <div class="home-instructions__steps">
        <div
          v-for="(step, index) in instructionSteps"
          :key="index"

          class="home-instructions__step"
        >
          <div class="home-instructions__icon">
            <img
              :src="step.image"
              :alt="step.alt"
            >
          </div>
          <div class="home-instructions__content">
            <h4 class="home-instructions__heading h4 fw-bold">{{ step.heading }}</h4>
            <p class="p" v-html="step.copy" />
          </div>
        </div>
      </div>
    </div>
  </module-block>
</template>

<script>
// Modules
import ModuleBlock from 'modules/Block';

// Images
const images = {
  computer: require(`images/info/icon-tooth-computer.svg`),
  tooth: require(`images/info/icon-tooth-search.svg`),
  people: require(`images/info/icon-doctors.svg`),
  aaoe: require(`images/info/american-association-of-endodontists.svg`),
};

export default {
  name: `info-dentists-instructions`,

  // Components
  components: {
    ModuleBlock,
  },

  // Data
  data () {
    return  {
      images,
      instructionSteps: [
        {
          image: images.computer,
          alt: `Icon - Online Verification`,
          heading: `Online Verification`,
          copy: `VeriTooth provides your dental office with a secure location to upload your \
                radiographs for review by a specialist. All patient and dentist information is \
                hidden to protect your privacy and ensure an unbiased review.`,
        },
        {
          image: images.tooth,
          alt: `Icon - Impartial Industry Expertise`,
          heading: `Impartial Industry Expertise`,
          copy: `An impartial qualified dental expert will then review the radiographs against industry defined standards. \
                For example, he/she will verify a root canal using the <a class="link link--secondary tdn" ` +
                `href="https://www.aae.org/" target="_blank">AAE</a> (American Association of Endodontists) <a class="link link--secondary tdn" ` +
                `href="https://f3f142zs0k2w1kg84k5p9i1o-wpengine.netdna-ssl.com/specialty/wp-content/uploads/` +
                `sites/2/2018/04/TreatmentStandards_Whitepaper.pdf" target="_blank">Standard of Treatment criteria</a>. \
                You'll then receive an email with a summary of the review.<br /><br />\
                <img src="${images.aaoe}" alt="Icon - American Association of Endodontist" />`,
        },
        {
          image: images.people,
          alt: `Icon - Demonstrated Quality`,
          heading: `Demonstrated Quality`,
          copy: `VeriTooth also takes these quality scores from all our reviews to build a directory of local dental care providers. \
                Now you can not only demonstrate great customer service, you can also demonstrate great clinical skill to current \
                and perspective patients.`,
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// Instructions.vue?10d22bdf